import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"DM_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-dm-sans\"}],\"variableName\":\"dmSans\"}");
;
import(/* webpackMode: "eager" */ "/app/src/components/footer/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderDesktop"] */ "/app/src/components/header/desktop/header-desktop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderMobile"] */ "/app/src/components/header/mobile/header-mobile.tsx");
